import {createSvgIcon} from "@mui/material";

const DeleteIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M4 4L12 12" stroke="currentColor" strokeLinecap="round"/>
    <path d="M12 4L4 12" stroke="currentColor" strokeLinecap="round"/>
  </svg>,
  'Delete'
)

export default DeleteIcon
